import { isString } from "@/utils"

export default decimal => value => {
  let number
  if (isString(value)) {
    const fixDecimal = value.replace(",", ".")
    number = parseFloat(fixDecimal)
  } else if (typeof value === "number") {
    number = value
  } else {
    return ""
  }
  if (!isFinite(number)) {
    return ""
  }
  return number.toFixed(decimal).replace(".", ",")
}
